import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL coverageS
export const coverageList = (params = '') => Http.get(`/showcase-coverages${serialize(params)}`)
export const coverageCreate = (params = '') => Http.post('/showcase-coverages', params)
export const coverageByID = (params = '') => Http.get(`/showcase-coverages/${params}`)
export const coverageUpdate = (params = '') => Http.put(`/showcase-coverages/${params.id}`, params)
export const coverageDestroy = (params = '') => Http.delete(`/showcase-coverages/${params.id}`)
export const coverageBulkPreview = (params) => Http.post('/showcase-coverages/bulk-preview', params)
export const coverageBulkStore = (params) => Http.post('/showcase-coverages/bulk-store', params)
